import { useLang } from "../i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = t("marquee.items");
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y select-none"
      style={{ borderColor: "#E5E2DC", background: "#FAF9F6" }}
      aria-hidden="true"
    >
      <div className="marquee-track py-4">
        {[0, 1].map((n) => (
          <span key={n} className="font-serif-display italic text-2xl sm:text-3xl text-[#5A5853] whitespace-nowrap pr-4">
            {items.repeat(4)}
            <span className="text-[#C83E2B] not-italic">✳</span>&nbsp;
          </span>
        ))}
      </div>
    </div>
  );
}
